module.exports = __webpack_public_path__ + "img/partner_gumtree.f613202.svg";